import React from "react";

import { IOutFeaturedDealDTO } from "@app/components/deal-cards/new-deal-card";
import { ClickableComponent, IClickableComponentProps } from "@app/core/clickable";
import IconChevronRight from "@assets/icons/chevron-right-sharp.svg";
import { DealCardWrapper } from "@app/components/deal-cards/deal-card-wrapper/deal-card-wrapper";
import { formatMessage } from "@app/translations/intl";

import styles from "../search-results.module.scss";

interface IProps {
  headerText: string;
  button: IClickableComponentProps;
  deals: IOutFeaturedDealDTO[];
  count?: number;
  closeSearch: () => void;
}

const component = ({ headerText, button, deals, count, closeSearch }: IProps) => {
  return (
    <div className={styles.searchResultContainer}>
      <div className={styles.header}>
        {headerText} {(count || 0) > 0 ? `(${count})` : ""}
      </div>
      <div className={styles.body}>
        <div className={styles.cardGrid}>
          {deals?.map((deal) => (
            <DealCardWrapper key={deal.id} deal={deal} responsive variant="mobile-search" />
          ))}
        </div>
        <div onClick={closeSearch} className={styles.link}>
          <ClickableComponent
            {...button}
            iconStyle="filled"
            iconRight={IconChevronRight}
            iconFillColor="white"
            iconSize="14px"
            variant="primary-2025-brand"
            href={formatMessage({ id: "global.dealOverviewLink" })}
          />
        </div>
      </div>
    </div>
  );
};

export const NavBarResultDeals = component;
